<template>
  <div class="row">
    <div class="sixty">
      <div class="envn" style="margin-left:10px">
      <h2>Hey there!</h2>
      <div v-show="!gotInvite">
        <p>Let's just find your invite...</p>
      </div>

      <div v-show="gotInvite">
        <p>So {{ account.name }}, here's the deal. </p>

        <p>We need your help to create something that will implement effective change, increase ROI, and make your team more awesome than they already are.</p>

        <p>You'll get to understand how your services actually work versus you think they work!</p>

        <p>Sound good?</p>
      </div>

      </div>
    </div>
    <div class="thirty" style="margin-left:auto; background-color:#fff">
      <div style="padding:10px;" v-show="!gotInvite">
        <progress-ring radius="60" :progress="inviteProgress" stroke="4"></progress-ring>
      </div>

      <div style="padding:10px;" v-show="gotInvite">
        <div v-show="isSaving">
          <progress-ring radius="60" :progress="progress" stroke="4"></progress-ring>
        </div>

        <div v-show="!isSaving">
        <div v-show="signupError">
          <h2>Looks like something broke!</h2>
          <p>{{ signupErrorMessage }}</p>
        </div>
        <form>
        <p>
        <label for="email">email</label>
        <input v-model="account.email" type="email" autocomplete="email" id="email" required>
        </p>
        <p>
        <label for="name">name</label>
        <input v-model="account.name" type="name" autocomplete="name" id="name" required>
        </p>
        <p>
        <label for="password">password</label>
        <input v-model="account.password" type="password" autocomplete="new-password" id="password" required>
        </p>
        <div class="row">
          <div class="fifty">
            <p>
              <label>
                 You're ok with our Privacy Policy <br>
              <toggle-button v-model="account.privacy" :labels="{checked: 'Yes', unchecked: 'No'}" :color="{checked: '#78C0A8', unchecked: '#FF0000', disabled: '#CCCCCC'}" />
              </label>
            </p>
          </div>
          <div class="fifty">
            <p>
              <label>
                 You're ok with our Terms and Conditions <br>
              <toggle-button v-model="account.terms" :labels="{checked: 'Yes', unchecked: 'No'}" :color="{checked: '#78C0A8', unchecked: '#FF0000', disabled: '#CCCCCC'}" />
              </label>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="fifty">
          </div>
          <div class="fifty">
            <input type="button" value="Sign up!" style="margin-right:20px" @click="createAccount()">
          </div>
        </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory } from '@/services/repositoryfactory'
import { ToggleButton } from 'vue-js-toggle-button';
import { Auth, Analytics } from 'aws-amplify'
import ProgressRing from '@/components/progress-ring.vue'
import uuidv4 from 'uuid/v4'
const OrgRepository = RepositoryFactory.get('organisation');

export default {
  name: 'invited',
  props: ['org', 'invite'],
  components: {
    ToggleButton,
    ProgressRing
  },
  data: () => ({
      signupError: false,
      isSaving: false,
      signupErrorMessage: "",
      gotInvite: false,
      inviteProgress: 10,
      progress: 0,
      account: {
        email: "",
        name: "",
        password: "",
        privacy: false,
        terms: false,
        id: "",
        orgName: ""
      },
      loginError: false
  }),
  metaInfo () {
    return {
      title: "You've been invited to the Slate"
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      const interval = setInterval(() => {
        this.inviteProgress += 1;
        if (this.inviteProgress === 100)
          clearInterval(interval);
      }, 100);

      const data = await OrgRepository.getInvite(this.org, this.invite);
      if(data.success === true) {
        this.account.name = data.invite.name;
        this.account.email = data.invite.email;
        this.account.id = this.org
        this.account.orgName = data.invite.orgName;
        this.gotInvite = true;
      } else {
        // we should error...
      }

    },
    createProfile: async function () {
      var created_on = Date.now().toString();
      var agreed_on = this.getNow();
      try {
        await Auth.signUp({
          'username': this.account.email,
          'password': this.account.password,
          attributes: {
            'email': this.account.email,
            'name': this.account.name,
            'updated_at': created_on,
            'custom:orgId': this.account.id,
            'custom:org': this.account.orgName,
            'custom:privacy': this.account.privacy.toString().toUpperCase(),
            'custom:privacy_agreed': agreed_on,
            'custom:terms': this.account.terms.toString().toUpperCase(),
            'custom:terms_agreed': agreed_on
          },
        });
        this.progress += 30;
      } catch (error){
        this.signupError = true;
        // bring the form back
        this.isSaving = false;
        // Swing back to the user account screen...
        this.sendAnalyticsEvent("invite-signup-screen-error");
        this.signupErrorMessage = error.message;
      }
    },

    getNow() {
      var date = new Date();
      var aaaa = date.getUTCFullYear();
      var gg = date.getUTCDate();
      var mm = (date.getUTCMonth() + 1);

      if (gg < 10) {
         gg = "0" + gg;
      }

      if (mm < 10) {
         mm = "0" + mm;
      }

      var cur_day = aaaa + "-" + mm + "-" + gg;
      var hours = date.getUTCHours()
      var minutes = date.getUTCMinutes()
      var seconds = date.getUTCSeconds();

      if (hours < 10) {
         hours = "0" + hours;
      }
      if (minutes < 10) {
         minutes = "0" + minutes;
      }
      if (seconds < 10) {
         seconds = "0" + seconds;
      }
      return cur_day + " " + hours + ":" + minutes + ":" + seconds +" UTC";
    },

    signInUser: async function() {
      // give Lambda a sec to confirm the user
      setTimeout(function() { return true; }, 1000);

      try {
        await Auth.signIn(this.account.email, this.account.password);
        this.progress += 30;
      } catch (error) {
        this.signupError = true;
        this.signupErrorMessage = "There was an error signing-in";
      }
    },

    sendAnalyticsEvent(eventName) {
      Analytics.record({
          name: "invite",
          attributes: {
              screen: eventName
          }
      });
    },

    acceptInvite: async function(){
      const data = await OrgRepository.confirmInvite(this.invite);
      if(data.status === false) {
        console.log("something went wrong");
      } else {
        this.progress += 30;
        return;
      }
    },

    createAccount: async function() {
      this.isSaving = true;
      this.progress += 10;

      await this.createProfile();
      await this.acceptInvite();
      await this.signInUser();

      if(this.signupError == false) {
        this.sendAnalyticsEvent("invite-screen-completed");
        this.$router.push({ path: "/" });
      }
    }
  }
}
</script>
